














































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import ActivityMessages from '@/components/ActivityMessages.vue'
import Api from '@/api'
import { User } from '@/classes/User'
import { EUserPermissions, IFacilityFiltersDTO } from '@zunta/configurations'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import { FacilityModule } from '@/store/modules/facility.module'
import Confirm from '@/components/Confirm.vue'
import BaseHeader from '@/components/layout/BaseHeader.vue'
import Tabs from '@/components/layout/Tabs.vue'
import AsyncSearchInput from '@/components/inputsV2/AsyncSearchInput.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'

@Component({
  components: {
    FacilityLabel,
    ResidentLabel,
    AsyncSearchInput,
    Tabs,
    BaseHeader,
    Icon,
    ActivityMessages,
    Confirm
  }
})
export default class Header extends Vue {
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  search: string = ''
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  query: IFacilityFiltersDTO = {
    limit: 20,
    skip: 0
  }
  showUpdateChainConfirmDialog: boolean = false

  get showSearch () {
    return this.$route.name !== 'management-facilities-login' &&
      this.$route.name !== 'management-facilities-import' &&
      this.$route.name !== 'management-facilities-agreements'
  }

  get residents () {
    return this.$store.state.resident.residentsQuickSearch
  }

  get tabsList () {
    const list = []
    // if (this.user.hasPermissionFor(EUserPermissions.VIEW_RESIDENTS)) {
    //   list.push({
    //     key: 'management-residents',
    //     value: { name: 'management-residents' },
    //     content: 'Residents'
    //   })
    // }
    list.push({
      key: 'management-todo',
      value: { name: 'management-todo' },
      content: 'To Do'
    })
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_MAILINGS)) {
      list.push({
        key: 'management-mailings',
        value: { name: 'management-mailings' },
        content: 'Statements'
      })
    }
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_PAYMENTS)) {
      list.push({
        key: 'management-payments',
        value: { name: 'management-payments' },
        content: 'Payments'
      })
    }
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_COLLECTIONS)) {
      list.push({
        key: 'management-collections',
        value: { name: 'management-collections' },
        content: 'Aging'
      })
    }
    return list
  }

  get isRootAccess () {
    return this.user.isRootAccess() && this.chain
  }

  get chain () {
    return this.$store.state.chain.chain
  }

  logout () {
    Api.logout()
    this.$router.push({ name: 'login' })
  }

  get routeQuery () {
    const query: any = { ...this.$route.query }
    if (query.limit) {
      query.limit = parseInt(query.limit)
    }
    if (query.skip) {
      query.skip = parseInt(query.skip)
    }
    if (query.residentsCount) {
      query.residentsCount = parseInt(query.residentsCount)
    }
    return query
  }

  async updateChain () {
    await this.chainModuleInstance.updateFacilitiesData({ chainId: this.chain.id })
    const query: any = this.query
    if (JSON.stringify(query) !== JSON.stringify(this.routeQuery)) {
      this.$router.push({
        query: {
          ...query
        }
      })
    }
    await this.facilityModuleInstance.getFacilityList(this.query)
    this.showUpdateChainConfirmDialog = false
  }
}
